import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import ContactPage from "@/pages/Contact";

export const Route = createFileRoute("/$lang/contact")({
  head: ({ params }) => pageHead(params.lang, "contact"),
  component: ContactPage,
});
